import ReactMarkdown from "react-markdown";
import { useSEO } from "@/hooks/use-seo";
import { seoFor } from "@/data/marketing-routes";
import remarkGfm from "remark-gfm";
import rehypeSlug from "rehype-slug";
import { PublicHeader } from "@/components/public-header";
import { PublicFooter } from "@/components/public-footer";
import { ShareFaqButton } from "@/components/share-faq-button";
import { HOST_FAQ_CONTENT } from "@/data/host-faq-content";

export default function PublicFaqHostPage() {
  useSEO(seoFor("/faq/hosts"));
  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="page-faq-host">
      <PublicHeader />
      <main className="flex-1 pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <div className="flex justify-end mb-4">
            <ShareFaqButton path="/faq/hosts" testId="button-share-faq-host" />
          </div>
          <article
            className="prose prose-sm sm:prose-base max-w-none prose-headings:scroll-mt-20 prose-h1:text-3xl prose-h2:text-xl prose-h2:mt-10 prose-h3:text-base prose-h3:mt-6 prose-a:text-blue-600 prose-blockquote:text-gray-600"
            data-testid="text-faq-host-content"
          >
            <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSlug]}>
              {HOST_FAQ_CONTENT}
            </ReactMarkdown>
          </article>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
